module.exports = __webpack_public_path__ + "img/step5.3d7975ae.png";